import { StepbystepApplicationStep } from 'embed/constants'

export const stepByStepCreditApplicationSteps: StepbystepApplicationStep[] = [
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Address,
]

export const stepByStepEarnRewardsCreditApplicationSteps: StepbystepApplicationStep[] = [
  StepbystepApplicationStep.CreditCardRewardsGroupsButtonList,
  StepbystepApplicationStep.CreditCardRedemptionTypes,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Address,
  StepbystepApplicationStep.AnnualIncome,
]

export const stepByStepNoRedemptionCreditApplicationSteps: StepbystepApplicationStep[] = [
  StepbystepApplicationStep.CreditCardRewardsGroupsButtonList,
  StepbystepApplicationStep.Email,
  StepbystepApplicationStep.Name,
  StepbystepApplicationStep.DateOfBirth,
  StepbystepApplicationStep.Address,
]
